import React, { useState, useEffect, useRef } from "react";
import ProductCard from "../../../components/ProductCard/ProductCard";
import AuthenticationForm from "../../../containers/SignInOutForm/Form";
import { AuthContext } from "../../../contexts/auth/auth.context";
import { ProductsRow, ProductsCol } from "./Products.style";
import { CURRENCY } from "../../../helper/constant";
import Button from "../../../components/Button/Button";
import { Spinner } from "react-bootstrap";
import Loader from "../../../components/Loader/Loader";
import { Modal } from "react-bootstrap";
import t from "../../../i18n/translate";
import { useCart } from "../../../contexts/cart/use-cart";
import { logPageView, logViewItem } from "../../../services/googleAnalytics";
import { logEventView } from "../../../services/googleAnalytics";

export const Products = ({
  deviceType,
  type,
  fetchLimit = 20,
  products,
  error,
  onProductClick,
  onCartClick,
  isFullWidth,
  loadMore = true,
  isHasMore = true,
  loading,
  onLoadMore,
  // onSeenProduct,
}) => {
  const { isloading, updateItem } = useCart();
  const [loader, setLoader] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const {
    authState: { isAuthenticated },
    authDispatch,
  } = React.useContext(AuthContext);
  const [showform, setShowForm] = useState(false);
  const [isSentGAEvent, setSentGAEvent] = useState(false);

  const isInViewport = () => {
    let screenWidth = 1200;
    if (window.screen.width < 800) {
      screenWidth = 1000;
    }
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - screenWidth &&
      loadMore &&
      isHasMore &&
      !loading
    ) {
      setLoader(true);
      handleLoadmore();
    } else {
      setLoader(false);
    }
  };

  const handleLoadmore = () => {
    console.log("Loading more products...");
    console.log(loadMore, isHasMore, loading);
    if (loadMore && isHasMore && !loading) {
      onLoadMore();
    }
    setLoader(false);
  };

  useEffect(() => {
    console.log("Setting up scroll event listener");
    document.addEventListener("scroll", isInViewport);
    return () => {
      document.removeEventListener("scroll", isInViewport);
    };
  }, [isHasMore, loading]);

  useEffect(() => {
    if (isloading) {
      document.getElementById("root").classList.add("loading");
    } else {
      document.getElementById("root").classList.remove("loading");
    }
  }, [isloading]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsFetching(false);
  //   }, 2600);
  // }, []);

  // const itemsRefs = useRef({});

  // useEffect(() => {
  //   if (!products?.length) return;
  //   const idsOnly = products.map(product => parseInt(product.item_id))
  //   const jsonIds = JSON.stringify(idsOnly)
  //   // localStorage.setItem("viewProductListRelated", jsonIds)
  //   if (!isSentGAEvent && idsOnly.length > 0) {
  //     logEventView("imageSearch", "Initial Image Search", idsOnly.length, jsonIds);
  //     setSentGAEvent(true);
  //   }

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           const id = entry.target.dataset.id;
  //           if (onSeenProduct) {
  //             onSeenProduct(id);
  //           }
  //           observer.unobserve(entry.target);
  //         }
  //       });
  //     },
  //     {
  //       root: null,
  //       rootMargin: "0px",
  //       threshold: 0,
  //     }
  //   );

  //   Object.values(itemsRefs.current).forEach((node) => {
  //     if (node) observer.observe(node);
  //   });

  //   return () => observer.disconnect();
  // }, [products, onSeenProduct]);

  return (
    <div className="d-block">
      <ProductsRow id="productList" isFullWidth={isFullWidth}>
        {error ? (
          <p>{error}</p>
        ) : products?.length ? (
          products.map((item, index) => (
            <ProductsCol
              key={index}
              data-id={item.item_id}
              // ref={(el) => (itemsRefs.current[item.item_id] = el)}
            >
              <ProductCard
                title={item.name}
                description={item.about_item}
                image={item.default_image_url}
                weight={
                  item.store_items_price_types[0].name !== " "
                    ? item.store_items_price_types[0].name
                    : item.store_items_price_types[0].weight +
                      " " +
                      item.store_items_price_types[0].weight_unit
                }
                outOfStock={!item.store_items_price_types[0].available_quantity}
                currency={CURRENCY}
                price={item.store_items_price_types[0].mrp}
                salePrice={item.store_items_price_types[0].price}
                isSameDay={item.same_day}
                discountInPercent={item.discountInPercent}
                data={item}
                deviceType={deviceType}
                onClick={() => onProductClick(item)}
                onCartClick={onCartClick}
                onUpdate={(quantity) => {
                  updateItem(item, quantity);
                }}
                promo={item.promo ? 1 : 0}
                promoPrice={item.promo ? item.promo_price : null}
                promoStartDate={item.promo ? item.promo_start_date : null}
                promoEndDate={item.promo ? item.promo_end_date : null}
                brandId={item.brand_id ? item.brand_id : 0}
                productCode={item.product_code}
              />
            </ProductsCol>
          ))
        ) : isFetching ? (
          <Spinner animation="border" style={{ color: "#9cc54b" }} />
        ) : (
          <p>{t("error_product_not_found")}</p>
        )}
      </ProductsRow>

      {loadMore && isHasMore && products.length > 0 && (
        <center>
          <Button
            onClick={handleLoadmore}
            type="button"
            disabled={loading}
            title={t("common_show_more_label", false)}
            size="small"
            intlButtonId="proceesCheckout"
            loader={<Loader />}
            isLoading={loading || loader}
            id="showMore"
            style={{
              display: loading || loader ? "block" : "inline-block",
              backgroundColor: "#E6E6E6",
            }}
          />
        </center>
      )}

      <Modal
        show={showform}
        onHide={() => setShowForm(false)}
        dialogClassName="modal-90w authModal"
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
      >
        <Modal.Header closeButton style={{ border: 0 }}></Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          <AuthenticationForm />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Products;